import { useAws } from "src/networking/aws";
import {
  AwsGateCallbacks,
  AwsGateRequest,
  GetDossier,
  GetDossierConfig,
} from "src/types";

export const useGetDossier = <
  T extends GetDossier["request"],
  D extends GetDossier["response"]
>() => {
  const hook = useAws<T, D>("getDossier");

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      request.headers = {
        ...request.headers,
        Canale: "GIVE",
      };
      return hook.crossGate(
        {
          method: "get",
          path: `/dossier/create`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const useGetDossierConfiguration = <
  T,
  D extends GetDossierConfig["response"]
>() => {
  const hook = useAws<T, D>("getDossierConfiguration");
  const application = "GIVE";

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "get",
          path: `/prodotti/${application}/config`,
          ...request,
        },
        callbacks
      );
    },
  };
};
